import { createBreakpointHook } from './createBreakpointHook';

export enum ScreenSizes {
  Small,
  Medium,
  Large,
}

const useScreenSizeBreakPoints = createBreakpointHook({
  [ScreenSizes.Small]: 0,
  [ScreenSizes.Medium]: 641,
  [ScreenSizes.Large]: 1008,
});

export function useScreenSize(size: ScreenSizes) {
  const currentSize = useScreenSizeBreakPoints();

  // intentionally using == for type coercion to match how enums as keys behave in typescript.
  return currentSize == size;
}
